import { cn } from "@/lib/utils";
import { Button } from "../ui/button";
import Image from "next/image";

interface ArrowButtonProps {
  className?: string;
  onClick?: () => void;
  disabled?: boolean;
}

const ArrowButton = ({ className, onClick, disabled }: ArrowButtonProps) => {
  return (
    <Button
      variant={"outline"}
      className={cn(
        className,
        "!bg-white items-center justify-center border border-gray-100 rounded-sm p-0 size-[34px]"
      )}
      onClick={onClick}
      disabled={disabled}
    >
      <Image
        src="/images/icons/left-arrow.svg"
        alt="Previous"
        width={16}
        height={16}
        className="size-4"
      />
    </Button>
  );
};

export default ArrowButton;
